import { BaseModel } from "../base.model";

export class RefKpi extends BaseModel {
  name: string;
}
